import { render } from "./CareerDepartment.vue?vue&type=template&id=605de3c2&scoped=true"
import script from "../js/career-department.js?vue&type=script&lang=js"
export * from "../js/career-department.js?vue&type=script&lang=js"

import "./CareerDepartment.vue?vue&type=style&index=0&id=605de3c2&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605de3c2"]])

export default __exports__